var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "point-page" },
    [
      _c(
        "el-collapse",
        {
          staticClass: "home-msg_collapse",
          model: {
            value: _vm.activeNames,
            callback: function ($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames",
          },
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { name: _vm.curName } },
            [
              _c("template", { slot: "title" }, [
                _c(
                  "div",
                  { staticClass: "spaceBetween home-msg_collapse_head" },
                  [
                    _c(
                      "div",
                      [
                        _c("svg-icon", {
                          staticClass: "icon-arrow",
                          attrs: { "icon-class": "tn-down" },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("Well " + _vm._s(_vm.wellIndex + 1)),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.removeDisabled
                      ? _c(
                          "span",
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top",
                                  width: "300",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  { staticClass: "spaceLeft popover-confirm" },
                                  [
                                    _c("i", { staticClass: "el-icon-warning" }),
                                    _vm._v("Are you sure you want to delete ?"),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "page-btns",
                                    staticStyle: {
                                      "text-align": "right",
                                      margin: "0",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      { attrs: { size: "mini" } },
                                      [_vm._v("Cancel")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: { click: _vm.deleteWell },
                                      },
                                      [_vm._v("Sure")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "time-text",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: { "icon-class": "tn-delete" },
                                    }),
                                    _vm._v(
                                      "\n                Delete\n              "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "addWellForm",
                      staticClass: "page-form point-form",
                      attrs: {
                        model: _vm.pageData,
                        rules: _vm.pageRules,
                        "label-position": "top",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 40 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "nickname",
                                    label: "Well Name",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "Please fill in",
                                    },
                                    model: {
                                      value: _vm.pageData.nickname,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.pageData, "nickname", $$v)
                                      },
                                      expression: "pageData.nickname",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 24 } }),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "location_id",
                                    label: "location_id",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "Please fill in",
                                    },
                                    model: {
                                      value: _vm.pageData.location_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.pageData,
                                          "location_id",
                                          $$v
                                        )
                                      },
                                      expression: "pageData.location_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "location",
                                    label: "location",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "Please fill in",
                                    },
                                    model: {
                                      value: _vm.pageData.location,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.pageData, "location", $$v)
                                      },
                                      expression: "pageData.location",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "aerLicensee",
                                    label: "AER Licensee",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "Please fill in",
                                    },
                                    model: {
                                      value: _vm.pageData.aerLicensee,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.pageData,
                                          "aerLicensee",
                                          $$v
                                        )
                                      },
                                      expression: "pageData.aerLicensee",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "aerLicenseNo",
                                    label: "AER License No",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "Please fill in",
                                    },
                                    model: {
                                      value: _vm.pageData.aerLicenseNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.pageData,
                                          "aerLicenseNo",
                                          $$v
                                        )
                                      },
                                      expression: "pageData.aerLicenseNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "aerSurfaceLocation",
                                    label: "AER surface location",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "Please fill in",
                                    },
                                    model: {
                                      value: _vm.pageData.aerSurfaceLocation,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.pageData,
                                          "aerSurfaceLocation",
                                          $$v
                                        )
                                      },
                                      expression: "pageData.aerSurfaceLocation",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "UWI", label: "AER UWI" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "Please fill in",
                                    },
                                    model: {
                                      value: _vm.pageData.UWI,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.pageData, "UWI", $$v)
                                      },
                                      expression: "pageData.UWI",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "APIGravity",
                                    label: "API Gravity",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "Please fill in",
                                    },
                                    model: {
                                      value: _vm.pageData.APIGravity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.pageData,
                                          "APIGravity",
                                          $$v
                                        )
                                      },
                                      expression: "pageData.APIGravity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "sulphur",
                                    label: "Sulphur Content",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        type: "text",
                                        "auto-complete": "off",
                                        placeholder: "Please fill in",
                                      },
                                      model: {
                                        value: _vm.pageData.sulphur,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.pageData, "sulphur", $$v)
                                        },
                                        expression: "pageData.sulphur",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("%"),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "fromToIDIdentifier",
                                    label: "FromToIDIdentifier",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      "auto-complete": "off",
                                      placeholder: "Please fill in",
                                    },
                                    model: {
                                      value: _vm.pageData.fromToIDIdentifier,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.pageData,
                                          "fromToIDIdentifier",
                                          $$v
                                        )
                                      },
                                      expression: "pageData.fromToIDIdentifier",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "oilAnalysis",
                                    label: "OIL ANALYSIS",
                                  },
                                },
                                [
                                  _c("file-upload", {
                                    attrs: {
                                      defaultFileList: _vm.pageData.oilAnalysis
                                        ? [
                                            {
                                              name: _vm.pageData.oilAnalysis,
                                              uid: _vm.pageData.oilAnalysis,
                                            },
                                          ]
                                        : undefined,
                                    },
                                    on: {
                                      onSuccess: function ($event) {
                                        return _vm.handleFileSuccess(
                                          $event,
                                          "oilAnalysis"
                                        )
                                      },
                                      onRemove: function ($event) {
                                        return _vm.handleFileRemove(
                                          $event,
                                          "oilAnalysis"
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 24 } }),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: "wellLisence",
                                    label: "WELL LISENCE",
                                  },
                                },
                                [
                                  _c("file-upload", {
                                    attrs: {
                                      defaultFileList: _vm.pageData.wellLisence
                                        ? [
                                            {
                                              name: _vm.pageData.wellLisence,
                                              uid: _vm.pageData.wellLisence,
                                            },
                                          ]
                                        : undefined,
                                    },
                                    on: {
                                      onSuccess: function ($event) {
                                        return _vm.handleFileSuccess(
                                          $event,
                                          "wellLisence"
                                        )
                                      },
                                      onRemove: function ($event) {
                                        return _vm.handleFileRemove(
                                          $event,
                                          "wellLisence"
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }